import React, { useEffect, useState } from "react";
import { Grid, Card, Typography, CardHeader, CardContent, Stack, Button, Box, Divider } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import { fDateTime } from "../../utils/formatTime";
import { capitalizeFirstLetter } from "../../utils/helpers";
import { apiOfferBannerManagement } from "../../services/AllServices";

const OfferAndBannerView = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiOfferBannerManagement.getById({ id: id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Box sx={{ width: '100%' }}>
      <Helmet>
        <title>Banner Management</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="Banner View" />
        <CardContent sx={{ p: 0, width: '100%' }}>
          <Grid container spacing={0} sx={{ width: '100%', margin: 0 }}>
            <Grid item xs={12} sx={{ width: '100%', padding: '24px' }}>
              <Card sx={{
                boxShadow: 4,
                borderRadius: 3,
                overflow: "hidden",
                width: '100%',
                maxWidth: 'none'
              }}>
                <CardContent sx={{ p: 0 }}>
                  <Box sx={{ width: '100%', mb: 3 }}>
                    <img
                      src={IMAGE_BASE + data?.bannerImage}
                      alt="Banner"
                      style={{
                        width: '100%',
                        height: '300px',
                        objectFit: 'cover',
                        borderRadius: '12px 12px 0 0'
                      }}
                    />
                  </Box>
                  <Box sx={{ p: 3 }}>

                    <Stack spacing={2}>
                      <Typography variant="h6">Title</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        {data?.title || ""}
                      </Typography>
                      <Divider></Divider>

                      <Typography variant="h6">Description</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        {data?.description || ""}
                      </Typography>
                      <Divider></Divider>

                      <Typography variant="h6">Start Date</Typography>
                      <Typography
                        variant="body1"
                        sx={{ overflowWrap: "break-word" }}
                        
                      >
                        {fDateTime(data?.visibilityPeriod?.startDate) || ""}
                      </Typography>
                      <Divider></Divider>



                      <Typography variant="h6">End Date</Typography>
                      <Typography
                        variant="body1"
                        sx={{ overflowWrap: "break-word" }}
                      >
                        {fDateTime(data?.visibilityPeriod?.endDate) || ""}
                      </Typography>
                      <Divider></Divider>

                      {data?.auctionId && (
                        <>

                          <Typography variant="h6">Auction</Typography>
                          <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                            {data?.auctionId?.vehicle?.make?.name + " " + data?.auctionId?.vehicle?.model || ""}
                          </Typography>
                          <Divider></Divider>
                        </>
                      )}

                    </Stack>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default OfferAndBannerView;